import {gql} from "@apollo/client";

export const TOGGLE_SIDEBAR = gql`
  mutation toggleSidebar {
    toggleSidebar
  }
`;
